
export class IncubatorPreferenceModel {
    constructor(
        public incubator_preference_1: string,
        public incubator_preference_2: string,
        public incubator_preference_3: string
    ) {
        this.incubator_preference_1 = incubator_preference_1;
        this.incubator_preference_2 = incubator_preference_2;
        this.incubator_preference_3 = incubator_preference_3;
    }
}